import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TermsPage from "./content/TermsPage";
import SuccessPage from './content/SuccessPage';
import FailedPage from './content/FailedPage';
import ErrorPage from './content/ErrorPage';
import SubscribePage from './content/SubscribePage';
import LoadPage from './content/LoadPage';

function App() 
{
  return (
    <Router>
      <Routes>
        <Route path="/main" element={<SubscribePage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/failed" element={<FailedPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/load2" element={<LoadPage enableAutoRedirect={process.env.REACT_APP_ENABLE_AUTO_REDIRECT !== 'false'} />} />
      </Routes>
    </Router>
  );
}

export default App;
